import { gql } from 'graphql-request'

const CREATE_APPLICATION = gql`
  mutation createApplication(
    $name: String!
    $plName: String!
    $vcName: String!
    $platform: ApplicationPlatformEnum
    $publisherId: ID!
    $rewardCallbackToken: String
    $rewardCallbackUrl: String
    $status: ApplicationStatusEnum!
    $plStatus: String!
    $storeUrl: String
    $notInStore: Boolean
    $exchangeRate: ExchangeRateCreateInput!
  ) {
    applicationCreate(
      input: {
        attributes: {
          name: $name
          platform: $platform
          publisherId: $publisherId
          rewardCallbackToken: $rewardCallbackToken
          rewardCallbackUrl: $rewardCallbackUrl
          status: $status
          storeUrl: $storeUrl
          notInStore: $notInStore
          virtualCurrencyAttributes: { name: $vcName }
          placementAttributes: {
            name: $plName
            status: $plStatus
            exchangeRatesAttributes: [$exchangeRate]
          }
        }
      }
    ) {
      application {
        id
        clientSecurityToken
        sdkSecurityToken
        name
        platform
        publisher {
          id
        }
        rewardCallbackToken
        rewardCallbackUrl
        status
        storeInfo
        storeUrl
        notInStore
        bundleId
        createdAt
        updatedAt
        placements {
          name
          isDefault
        }
        virtualCurrencies {
          name
          textIdentifier
          isDefault
        }
      }
      errors
    }
  }
`
export default CREATE_APPLICATION
